import { api } from "@/modules/api";
import { useQuery } from "@tanstack/react-query";
import { FC, useMemo } from "react";
import { FlipDotLoader } from "@/components/flip-dot-loader";
import styled from "@emotion/styled";

export const HomePage: FC = () => {
  const result = useQuery({
    queryKey: ["account", "me"],
    queryFn: () => api.get("/v1/me/account", {}),
  });

  const greetingMessage = useMemo(() => {
    const displayName = result.data?.data?.profile_display_name;
    const firstName = displayName?.split(" ")[0] ?? "there";

    const currentHour = new Date().getHours();
    let greeting;

    if (currentHour < 12) {
      greeting = "Good morning";
    } else if (currentHour < 18) {
      greeting = "Good afternoon";
    } else {
      greeting = "Good evening";
    }

    return `${greeting}, ${firstName}!`;
  }, [result.data?.data?.profile_display_name]);

  return (
    <Container>
      <h1>Home</h1>
      {result.isLoading ? <FlipDotLoader /> : <GreetingText>{greetingMessage}</GreetingText>}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const GreetingText = styled.div`
  font-size: 18px;
  color: var(--gray-12);
`;
